import React from 'react';

// Themed surface. Renders a div.ss-card; extra className/props pass through.
export default function Card({ className = '', children, ...rest }) {
  return (
    <div className={`ss-card ${className}`.trim()} {...rest}>
      {children}
    </div>
  );
}
